module.exports = __webpack_public_path__ + "img/small_logo.43e1ba33.svg";